import Container from '@/components/Container';
import PrimaryTitle from '@/components/PrimaryTitle';
import Lead from '@/components/Lead';
import SalesForm from '@/domain/SalesForm';

export default function Contact() {
  return (
    <div className="relative flex flex-col space-y-10 bg-gray-100 py-10 lg:space-y-16 lg:py-20">
      <Container maxWidth="max-w-screen-lg" className="relative z-10">
        <div className="space-y-4 text-center lg:space-y-6">
          <PrimaryTitle fontSize="text-2xl md:text-5xl lg:px-10 tracking-tight">
            Contáctenos
          </PrimaryTitle>
          <Lead>
            <div className="leading-relaxed">
              Nuestro equipo comercial estará encantado de responder a sus
              preguntas sobre ventas. Complete el siguiente formulario y nos
              pondremos en contacto lo antes posible.
            </div>
          </Lead>
        </div>
      </Container>
      <Container
        maxWidth="max-w-screen-md"
        className="relative z-10 space-y-10"
      >
        <div className="mx-auto max-w-screen-sm rounded-lg bg-white shadow-lg lg:rounded-xl lg:shadow-2xl xl:rounded-2xl">
          <div className="p-10">
            <SalesForm />
          </div>
        </div>
        <div className="mx-auto grid max-w-screen-sm rounded-lg bg-white p-8 shadow-lg md:flex md:gap-6 lg:rounded-xl lg:shadow-xl xl:rounded-2xl">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="42"
              height="42"
              viewBox="0 0 42 42"
            >
              <g fill="none" fillRule="evenodd" transform="translate(0 2)">
                <path
                  className="fill-current text-green-400"
                  d="M23.3687586,30.1425368 C20.9219925,32.1886371 17.7706231,33.4201682 14.3316134,33.4201682 C11.6954209,33.4201682 9.22824798,32.6965111 7.11790903,31.4370107 L0.720671335,33.5694159 C0.184840538,33.7480255 -0.0887912638,33.4605854 0.0863663199,32.9351109 L2.21876868,26.5378816 C0.959266296,24.4275489 0.235608095,21.9603837 0.235608095,19.3241995 C0.235608095,11.8043462 6.12405444,5.6598097 13.5415258,5.25 C11.8174159,7.83464563 10.8124059,10.939934 10.8124059,14.279955 C10.8124059,21.9925795 16.1713145,28.4535638 23.3687608,30.1425372 Z"
                />
                <path
                  className="fill-current text-green-200"
                  d="M39.33385,21.3096508 C40.5933524,19.1993181 41.3170106,16.7321529 41.3170106,14.0959687 C41.3170106,6.31098016 35.0060141,1.77635684e-14 27.2210053,1.77635684e-14 C19.4359965,1.77635684e-14 13.125,6.31098016 13.125,14.0959687 C13.125,21.8809573 19.4359965,28.1919374 27.2210053,28.1919374 C29.8571978,28.1919374 32.3243707,27.4682803 34.4347097,26.2087798 L40.8319474,28.341185 C41.3677782,28.5197947 41.64141,28.2323546 41.4662524,27.70688 L39.33385,21.3096508 Z"
                />
                <ellipse
                  cx="22.313"
                  cy="16.188"
                  className="fill-current text-green-900"
                  rx="1.313"
                  ry="1.313"
                />
                <ellipse
                  cx="27.125"
                  cy="16.188"
                  className="fill-current text-green-900"
                  rx="1.313"
                  ry="1.313"
                />
                <ellipse
                  cx="31.938"
                  cy="16.188"
                  className="fill-current text-green-900"
                  rx="1.313"
                  ry="1.313"
                />
              </g>
            </svg>
          </div>
          <div className="space-y-2 md:flex-1">
            <h4 className="text-lg font-semibold">Comunicación general</h4>
            <div className="text-gray-700">
              Para consultas generales, incluidas oportunidades de asociación,
              envíe un correo electrónico a&nbsp;
              <a
                href="mailto:info@aibes.org"
                className="font-medium text-gray-900"
              >
                info@aibes.org
              </a>
              .
            </div>
          </div>
        </div>
      </Container>
      <div className="absolute bottom-0 left-0 right-0 z-0 hidden h-3/5 lg:block">
        <div className="absolute inset-0 w-full  -skew-y-6 transform bg-green-500" />
        <div className="absolute left-0 right-0 bottom-0 h-2/5 bg-green-500" />
      </div>
    </div>
  );
}
